var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowAssetsManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#323232"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5486_2615",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5486_2615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6387 56.6112L48.3333 54.4446C47.7963 54.2685 47.3033 54.0485 46.8541 53.7846C46.4049 53.5207 45.9998 53.2314 45.6387 52.9167L43.6666 53.7221L42.1387 51.2779L43.8333 49.8887C43.7221 49.426 43.6666 48.9214 43.6666 48.375C43.6666 47.8286 43.7221 47.324 43.8333 46.8612L42.1387 45.4721L43.6666 43L45.6387 43.8054C45.9998 43.5093 46.4049 43.2293 46.8541 42.9654C47.3033 42.7015 47.7963 42.4815 48.3333 42.3054L48.6387 40.1112H51.4166L51.7499 42.3054C52.2869 42.4815 52.7799 42.7015 53.2291 42.9654C53.6783 43.2293 54.0834 43.5093 54.4445 43.8054L56.4166 43L57.9445 45.4721L56.2499 46.8612C56.361 47.324 56.4166 47.8286 56.4166 48.375C56.4166 48.9214 56.361 49.426 56.2499 49.8887L57.9445 51.2779L56.4166 53.7221L54.4445 52.9167C54.0834 53.2314 53.6783 53.5207 53.2291 53.7846C52.7799 54.0485 52.2869 54.2685 51.7499 54.4446L51.4166 56.6112H48.6387ZM50.0278 52.3054C51.1481 52.3054 52.0856 51.9282 52.8403 51.1737C53.5948 50.419 53.972 49.4815 53.972 48.3612C53.972 47.2407 53.5948 46.3032 52.8403 45.5487C52.0856 44.794 51.1481 44.4167 50.0278 44.4167C48.9073 44.4167 47.9698 44.794 47.2153 45.5487C46.4606 46.3032 46.0833 47.2407 46.0833 48.3612C46.0833 49.4815 46.4606 50.419 47.2153 51.1737C47.9698 51.9282 48.9073 52.3054 50.0278 52.3054ZM26.1112 50.5554V29.4446V37.9446V37.2221V50.5554ZM26.1112 53.3333C25.3612 53.3333 24.7106 53.0532 24.1595 52.4929C23.6087 51.9329 23.3333 51.2871 23.3333 50.5554V29.4446C23.3333 28.7129 23.6087 28.0671 24.1595 27.5071C24.7106 26.9468 25.3612 26.6667 26.1112 26.6667H37.2499L40.0278 29.4446H53.8887C54.6203 29.4446 55.2662 29.7246 55.8262 30.2846C56.3864 30.8449 56.6666 31.4907 56.6666 32.2221V39.4304C56.2408 39.1065 55.8009 38.8265 55.347 38.5904C54.8934 38.3543 54.4073 38.139 53.8887 37.9446V32.2221H38.8749L36.097 29.4446H26.1112V50.5554H39.1528C39.2545 51.0462 39.3817 51.5232 39.5345 51.9862C39.6873 52.449 39.8795 52.898 40.1112 53.3333H26.1112Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowAssetsManager);
export default __webpack_public_path__ + "static/media/icon-flow-assets-manager.d49187a4f5bc59379ab7117760b2879c.svg";
export { ForwardRef as ReactComponent };